import {
    isDataDoisMil
} from "../../../../../core/utils/UtilityDates.ts";

export function getEstiloFrota(props) {
    return {
        control: (provided) => ({
            ...provided,
            minHeight: "30px",
            minWidth: "150px",
            borderRadius: "7px",
            border: "1px solid var(--Background-Input, #F2F2F2)",
            background: "var(--Background-Input, #F2F2F2)",
            "&:hover": {
                background: "#F0F6FF",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "var(--Placeholder-Color, #888)",
            fontSize: "12px",
        }),
        menu: (provided) => ({
            ...provided,
            width: "max-content",
            minWidth: props.classeCss ? props.classeCss : "250px",
            zIndex: 5,
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: "13px",
        }),
        option: (provided) => ({
            ...provided,
            fontSize: "13px",
        }),
    };

}

export function isDateTimeInRange(dateTimeStr) {
    if (!dateTimeStr) return false;
    const date = new Date(dateTimeStr);
    const min = new Date("1900-01-01T00:00");
    const max = new Date("2050-12-31T23:59");
    return date >= min && date <= max;
}

export const validateCadastro = (currentValues) => {
    return {
        ...currentValues,
        dataEmbarque:
            !currentValues.dataEmbarque || currentValues.dataEmbarque === "2000-01-01"
                ? null
                : currentValues.dataEmbarque,
        dataEntrega:
            !currentValues.dataEntrega || currentValues.dataEntrega === "2000-01-01"
                ? null
                : currentValues.dataEntrega,
        previsaoEmbarque:
            !currentValues.previsaoEmbarque ||
            currentValues.previsaoEmbarque === "2000-01-01T00:00:00" ||
            currentValues.previsaoEmbarque === "2000-01-01T00:00"
                ? null
                : currentValues.previsaoEmbarque,
        previsaoEntrega:
            !currentValues.previsaoEntrega ||
            currentValues.previsaoEntrega === "2000-01-01T00:00:00" ||
            currentValues.previsaoEntrega === "2000-01-01T00:00"
                ? null
                : currentValues.previsaoEntrega,
        dataHoraChegadaEmbarque:
            !currentValues.dataHoraChegadaEmbarque ||
            currentValues.dataHoraChegadaEmbarque === "2000-01-01T00:00:00" ||
            currentValues.dataHoraChegadaEmbarque === "2000-01-01T00:00"
                ? null
                : currentValues.dataHoraChegadaEmbarque,
        dataHoraChegadaEntrega:
            !currentValues.dataHoraChegadaEntrega ||
            currentValues.dataHoraChegadaEntrega === "2000-01-01T00:00:00" ||
            currentValues.dataHoraChegadaEntrega === "2000-01-01T00:00"
                ? null
                : currentValues.dataHoraChegadaEntrega,
        dataHoraEntregue:
            !currentValues.dataHoraEntregue ||
            currentValues.dataHoraEntregue === "2000-01-01T00:00:00" ||
            currentValues.dataHoraEntregue === "2000-01-01T00:00"
                ? null
                : currentValues.dataHoraEntregue,
        dataHoraEmbarcado:
            !currentValues.dataHoraEmbarcado ||
            currentValues.dataHoraEmbarcado === "2000-01-01T00:00:00" ||
            currentValues.dataHoraEmbarcado === "2000-01-01T00:00"
                ? null
                : currentValues.dataHoraEmbarcado,
        adicionalEmpresa:
            currentValues.adicionalEmpresa?.split(",").length === 1
                ? currentValues.adicionalEmpresa + ",00"
                : currentValues.adicionalEmpresa,
        adicionalMotorista:
            currentValues.adicionalMotorista?.split(",").length === 1
                ? currentValues.adicionalMotorista + ",00"
                : currentValues.adicionalMotorista,
        adiantamento:
            currentValues.adiantamento?.split(",").length === 1
                ? currentValues.adiantamento + ",00"
                : currentValues.adiantamento,
        saldo:
            currentValues.saldo?.split(",").length === 1
                ? currentValues.saldo + ",00"
                : currentValues.saldo,
        classificacao:
            currentValues.classificacao?.split(",").length === 1
                ? currentValues.classificacao + ",00"
                : currentValues.classificacao,
    };
};

export const validateDatasEntregas = (currentValues) => {
    if (!currentValues.length) return [];
    return currentValues.map((item) => {
        return {
            ...item,
            dataHoraChegadaEntrega:
                isDataDoisMil(item.dataHoraChegadaEntrega) ||
                item.dataHoraChegadaEntrega === ""
                    ? null
                    : item.dataHoraChegadaEntrega,
            dataHoraEntregue:
                isDataDoisMil(item.dataHoraEntregue) || item.dataHoraEntregue === ""
                    ? null
                    : item.dataHoraEntregue,
        };
    });
};